import React from "react";
import { PlusIcon } from "lucide-react";
import { Button } from "../../../components/ui/button";

interface NoFormsFoundProps {
	onCreateNewForm: () => void;
}

const NoFormsFound: React.FC<NoFormsFoundProps> = ({ onCreateNewForm }) => {
	return (
		<div className="flex flex-col items-center justify-center h-screen gap-4">
			<h2 className="text-xl font-semibold text-gray-700">
				Keine Formulare gefunden
			</h2>
			<p className="text-gray-500 mb-4">
				Erstellen Sie ein neues Formular, um zu beginnen
			</p>
			<Button
				onClick={onCreateNewForm}
				className="flex items-center gap-2"
			>
				<PlusIcon className="h-4 w-4" />
				Neues Formular erstellen
			</Button>
		</div>
	);
};

export default NoFormsFound;
